import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
/** QA-009: human attestation is separate from automated CheckResult rows. */
export const ManualQaAttestationV1Schema = z
    .object({
    schemaVersion: z.literal("manual-qa-attestation.v1.0"),
    attestationId: z.string().min(1),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    artifactSetHash: z.string().min(1),
    reviewerId: z.string().min(1),
    manualCheckArea: z.string().min(1),
    attestedAt: z.string().datetime(),
    notes: z.string().max(2000).optional(),
})
    .strict();
//# sourceMappingURL=manual-qa-attestation.js.map